import request from '@/request'

export async function sendContactMessage (data) {
  const response = await request({
    url: `/support/contact`,
    method: 'post',
    data
  })

  return response.data.data
}

export async function getSupportFAQIndex () {
  const response = await request({
    url: `/support/faq`,
    method: 'get'
  })

  return response.data
}